import { formatDuration } from "./formatters";

const COLORS = {
  manual: "#f59e0b",
  auto: "#7c3aed",
};

export default function PauseBreakdown({
  manualPauseSeconds = 0,
  autoPauseSeconds = 0,
}) {
  const manual = Math.max(0, Number(manualPauseSeconds) || 0);
  const auto = Math.max(0, Number(autoPauseSeconds) || 0);
  const total = manual + auto;

  if (!total) {
    return <p className="pa-empty">No pause time in this period.</p>;
  }

  const manualPct = Math.round((manual / total) * 100);
  const autoPct = 100 - manualPct;

  return (
    <div>
      <div className="pa-breakdown" aria-hidden="true">
        <span style={{ width: `${manualPct}%`, background: COLORS.manual }} />
        <span style={{ width: `${autoPct}%`, background: COLORS.auto }} />
      </div>
      <div className="pa-pause-split">
        <p>
          <i className="pa-dot" style={{ background: COLORS.manual }} />
          Manual pause
          <strong>{formatDuration(manual)}</strong>
          <span>{manualPct}%</span>
        </p>
        <p>
          <i className="pa-dot" style={{ background: COLORS.auto }} />
          Auto-paused
          <strong>{formatDuration(auto)}</strong>
          <span>{autoPct}%</span>
        </p>
      </div>
    </div>
  );
}
